import React from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";

export default function TwListMoreButton(props) {
  const loadingReduxState = useSelector(loadingState);
  const { children, type = "button", className = "", } = props
  let inputProps = { ...props }
  delete inputProps.children
  delete inputProps.className
  return (
    <button
      type={type}
      className={classNames("w-full text-left px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none hover:bg-gray-50 hover:outline-none focus:bg-gray-50 focus:outline-none disabled:text-gray-300", className)}
      // disabled
      onClick={props?.onClick ? props.onClick : () => { }}
      {...inputProps}
    >
      {children}
    </button>
  );
}
